// #region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
// #endregion

// #region types
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { WintSuperkollAPIModelWintSalaryDeviations } from "wint-api-client/dist/types";
// #endregion

// #region components
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import ChildCreateFormContainer from "./forms/childCreateFormContainer";
// #endregion

function useChildCreateDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const getChildCreateDialog = (
    personId: number,
    onChildCreated?: (child: WintSuperkollAPIModelWintSalaryDeviations.Child) => void,
    onDialogClosed?: () => void
  ): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.CreateChildDialogTitle),
    titleIcon: IconDefinitionConstants.WChild,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
        successMessage: TranslationKeys.SalaryDeviation.ChildCreatedSuccess,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    maxWidth: "sm",
    children: <ChildCreateFormContainer personId={personId} onChildCreated={onChildCreated} />,
    onClose: onDialogClosed,
  });

  const showChildCreateDialog = (
    personId: number,
    onChildCreated?: (child: WintSuperkollAPIModelWintSalaryDeviations.Child) => void,
    onDialogClosed?: () => void
  ) => {
    dispatch(displayDialog(getChildCreateDialog(personId, onChildCreated, onDialogClosed)));
  };

  return { showChildCreateDialog };
}

export default useChildCreateDialog;
